import React, { useState, useEffect } from 'react'
import { useSelector } from '../../../hooks/useSelector'
import PromiseButton from '../../../components/PromiseButton'
import { Button, Card, CardBody, CardFooter, CardHeader, Input, Modal, Stack, Typography } from '@prometheus/components'
import PromiseButtonV2 from '@/components/PromiseButtonV2'

interface CreateGameModalProps {
  open: boolean
  setOpen: (state: boolean) => any
  onSubmit: (name: string, tutorial?: boolean) => any
}

export const CreateGameModal = ({ open, onSubmit, setOpen }: CreateGameModalProps) => {
  const displayName = useSelector(s => s.auth.displayName)
  const [name, setName] = useState<string>(`${displayName || 'Anonymous'}'s Game`)
  useEffect(() => {
    setName(`${displayName || 'Anonymous'}'s Game`)
  }, [displayName])
  if (!open) {
    return;
  }
  return (
    <Modal onClose={() => setOpen(false)}>
      <Card style={{ width: '400px', maxWidth: '100%' }}>
        <CardHeader><Typography retro color="primary" variant="h3">Create Game</Typography></CardHeader>
        <CardBody>
          <Input label="Game Name" value={name} size="lg" onChange={(e) => setName(e.target.value)} />
        </CardBody>
        <CardFooter>
          <Stack direction="row" style={{ justifyContent: 'space-between', width: '100%', flexWrap: 'wrap', gap: 'var(--prometheus-spacing-sm)' }}>
            <PromiseButtonV2 variant="tertiary" outline onClick={() => onSubmit(name, true)}>Play Tutorial (WIP)</PromiseButtonV2>
            <Stack direction="row">
              <Button variant="dark" onClick={() => setOpen(false)}>Cancel</Button>
              <PromiseButtonV2 onClick={() => onSubmit(name)}>Create</PromiseButtonV2>
            </Stack>
          </Stack>
        </CardFooter>
      </Card>
    </Modal>
  )
}
